var ReactTooltipRenderer = /** @class */ (function () {
    function ReactTooltipRenderer(ReactDOM) {
        this._reactDOM = ReactDOM;
    }
    ReactTooltipRenderer.prototype.init = function () { };
    ReactTooltipRenderer.prototype.update = function (dom, formatContent) {
        var _this = this;
        this._reactDOM.render(formatContent, dom, function () {
            if (_this.updateCallback) {
                _this.updateCallback();
            }
        });
    };
    ReactTooltipRenderer.prototype.destroy = function (dom) {
        this._reactDOM.unmountComponentAtNode(dom);
    };
    return ReactTooltipRenderer;
}());
export default ReactTooltipRenderer;
